// extracted by mini-css-extract-plugin
export default {"feedbackSlide":"ReviewClient_feedbackSlide__8F2ut","quoteRow":"ReviewClient_quoteRow__8tMph","feedbackImg":"ReviewClient_feedbackImg__v-vAy","starRow":"ReviewClient_starRow__PORkp"};